import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { projects } from "../../data/portfolio";
import { SectionHead } from "./Reveal";

export default function Projects() {
  return (
    <section id="research" data-testid="research-section" className="relative py-28 md:py-40 overflow-hidden">
      <div className="absolute rounded-full mix-blend-multiply blur-3xl opacity-40 bg-stone w-96 h-96 top-10 -right-32 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionHead eyebrow="Selected research" title={<>Questions worth<br />answering carefully.</>} testid="research-heading" />
        <div className="border-t border-stone/80">
          {projects.map((p, i) => (
            <motion.article
              key={p.index}
              data-testid={`project-row-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], delay: i * 0.06 }}
              className="group relative border-b border-stone/80 py-9 md:py-11 grid grid-cols-12 gap-4 md:gap-8 items-start transition-[background-color,padding] duration-500 hover:bg-white/50 hover:px-6 md:hover:px-8 rounded-none"
            >
              <span className="col-span-2 md:col-span-1 font-display italic text-lg text-ink/40 pt-1.5">{p.index}</span>
              <div className="col-span-10 md:col-span-6">
                <h3 className="font-display text-2xl md:text-[1.75rem] font-medium leading-snug tracking-tight text-ink">
                  {p.title}
                </h3>
                <p className="mt-2 text-xs font-semibold tracking-[0.18em] uppercase text-fog">{p.type} · {p.year}</p>
              </div>
              <div className="col-span-12 md:col-span-4 md:col-start-8">
                <p className="text-sm leading-relaxed text-fog">{p.blurb}</p>
                <div className="mt-4 flex flex-wrap gap-2">
                  {p.tags.map((t) => (
                    <span key={t} className="pill-tag">{t}</span>
                  ))}
                </div>
              </div>
              <ArrowUpRight className="hidden md:block col-span-1 justify-self-end w-5 h-5 mt-2 text-ink/30 transition-all duration-500 group-hover:text-ink group-hover:translate-x-1 group-hover:-translate-y-1" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
